import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) { }

  /**
   * loadJsScript
   * @param id
   * @param src
   * @param onload
   * @returns
   */
  public loadJsScript(id: string, src: string, onload: GlobalEventHandlers['onload']): HTMLScriptElement {
    // caricamento dinamico dello script
    const script = document.createElement('script');
    script.text = src;

    if (onload) {
      script.onload = onload;
    }

    script.id = id;

    document.querySelector('head')?.appendChild(script);
    script.setAttribute('data-cookieconsent', 'ignore');
    return script;
  }
}
